import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, createUrlTreeFromSnapshot} from '@angular/router';
import { map } from 'rxjs';
import { UserAuthService }  from "../services/user-auth.service";

export const otpValidGuard = (next: ActivatedRouteSnapshot) => {
  const service = inject(UserAuthService);
return service
  .isOtpValid()
  .pipe(
    map((isOTPValid) =>
      isOTPValid ? true : createUrlTreeFromSnapshot(next, ['/', 'cv-comp'])
    )
  );
};